<!--<section class="page-header">
  <h2>Il mio ordine</h2>
  <h1 *ngIf="cartData && cartData.order">{{cartData.order.euro_total}} &euro;</h1>
</section>-->
<app-header-one [class]="'header-gym'"></app-header-one>
<section class="section-b-space cashpay-page">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3">
        <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
        <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Checkout'"></app-navigation-bar></div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-9 mt-5">
        <div class="row mt-5">
          <div class="col-xl-6 col-12">
            <div class="checkout-page">
              <div class="checkout-title m-0">
                <h3>Pagamento con Satispay</h3>
              </div>
              <div class="checkout-form py-3 d-flex align-items-center gap-4">
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-start p-title my-3">
                  Attendi mentre il tuo pagamento viene elaborato
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 d-none d-md-block">
            <app-cart-box [editable]="false" [loader]="false" [showCoupon]="false" [showProducts]="false">
            </app-cart-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="total-section fixed-b py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section> -->
<section class="total-section py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>